<div class="pre-prestador-container">
    <form [formGroup]="form">
        <div class="form-actions">
            @if (isAnuidadePaga() !== null) {
                <span class="anuidade-badge" [class.paga]="isAnuidadePaga()" [class.nao-paga]="!isAnuidadePaga()">{{ anuidadeRotulo() }}</span>
            }
            <!--
                Salvar/Cancelar ficam AQUI, em botão, e só enquanto a edição está aberta: nessa hora são
                as duas únicas saídas, e escondê-las atrás de um menu custaria um clique a mais em cada
                uma. Quem abre a edição é o item "Editar" do menu de Ações, no cabeçalho do card — ver
                `card-servicos`.
            -->
            @if (editando()) {
                <p-button type="button" label="Salvar" icon="pi pi-save" [appCan]="rolePrePrestadorEditar" (onClick)="salvarEdicao()" />
                <p-button type="button" label="Cancelar" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="cancelarEdicao()" />
            }
        </div>

        @if (abaSelecionada() === EAbaPrePrestador.DADOS) {
            <app-card-content [headerColor]="false" [title]="'Dados Diretor Tecnico'" [icon]="iconeDaSecao('Dados Diretor Tecnico')" [subtitle]="subtituloDaSecao('Dados Diretor Tecnico')">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div class="field md:col-span-2">
                        <label class="font-semibold block mb-2">Nome</label>
                        <input pInputText formControlName="diretorNome" class="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">CRM</label>
                        <input pInputText formControlName="diretorCrm" class="w-full" />
                    </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">UF</label>
                        <p-select formControlName="diretorUf" [options]="ufs" placeholder="UF" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">CPF</label>
                        <p-inputmask formControlName="diretorCpf" mask="999.999.999-99" placeholder="000.000.000-00" styleClass="w-full" />
                    </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">Email Diretor Técnico</label>
                        <input pInputText formControlName="diretorEmail" class="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Email Empresa</label>
                        <input pInputText formControlName="empresaEmail" class="w-full" />
                    </div>
                </div>
            </app-card-content>

            <app-card-content [headerColor]="false" [title]="'Dados Prestador'" [icon]="iconeDaSecao('Dados Prestador')" [subtitle]="subtituloDaSecao('Dados Prestador')">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">Razão Social</label>
                        <input pInputText formControlName="razaoSocial" class="w-full" />
                    </div>
                </div>

                <div class="field">
                    <label class="font-semibold block mb-2">Nome Fantasia</label>
                    <input pInputText formControlName="nomeFantasia" class="w-full" />
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">CNPJ</label>
                        <p-inputmask formControlName="cnpj" mask="99.999.999/9999-99" placeholder="00.000.000/0000-00" styleClass="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Classificação</label>
                        <input pInputText formControlName="classificacao" class="w-full" />
                    </div>
                </div>

                <div class="field">
                    <label class="font-semibold block mb-2">Instalações</label>
                    <p-selectbutton [options]="instalacoesOptions" formControlName="instalacoes" optionLabel="label" optionValue="value" [multiple]="false" styleClass="pre-prestador-selectbutton" />
                </div>
            </app-card-content>

            <app-card-content [headerColor]="false" [title]="'Endereço'" [icon]="iconeDaSecao('Endereço')" [subtitle]="subtituloDaSecao('Endereço')">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">CEP</label>
                        <p-inputmask formControlName="cep" mask="99999-999" placeholder="00000-000" styleClass="w-full" />
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-[3fr_auto_1fr] gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">Logradouro</label>
                        <input pInputText formControlName="logradouro" class="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Número</label>
                        <input pInputText formControlName="numero" class="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Bairro</label>
                        <input pInputText formControlName="bairro" class="w-full" />
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">Complemento</label>
                        <input pInputText formControlName="complemento" class="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Cidade</label>
                        <input pInputText formControlName="cidade" class="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Estado</label>
                        <p-select formControlName="estado" [options]="ufs" placeholder="UF" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                </div>
            </app-card-content>

            <app-card-content [headerColor]="false" [title]="'Contato'" [icon]="iconeDaSecao('Contato')" [subtitle]="subtituloDaSecao('Contato')">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">DDD</label>
                        <p-inputmask formControlName="ddd" mask="99" placeholder="00" styleClass="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Telefone</label>
                        <p-inputmask formControlName="telefone" mask="99999-9999" placeholder="00000-0000" styleClass="w-full" />
                    </div>
                </div>
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaPrePrestador.FUNC) {
            <app-card-content [headerColor]="false" [title]="'Natureza Juridica e Classificacao'" [icon]="iconeDaSecao('Natureza Juridica e Classificacao')" [subtitle]="subtituloDaSecao('Natureza Juridica e Classificacao')">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">Tipo</label>
                        <p-select formControlName="funcionamentoNaturezaTipo" [options]="naturezaTipoOptions" placeholder="Selecionar" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Esfera</label>
                        <p-select formControlName="funcionamentoNaturezaEsfera" [options]="naturezaEsferaOptions" placeholder="Selecionar" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">Modalidade</label>
                        <p-select formControlName="funcionamentoModalidade" [options]="modalidadeOptions" placeholder="Selecionar" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Categoria</label>
                        <p-select formControlName="funcionamentoCategoria" [options]="categoriaOptions" placeholder="Selecionar" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">Tipo Organização</label>
                        <p-select formControlName="funcionamentoTipoOrganizacao" [options]="tipoOrganizacaoOptions" placeholder="Selecionar" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Capital Social</label>
                        <input pInputText formControlName="funcionamentoCapitalSocial" class="w-full" />
                    </div>
                </div>
            </app-card-content>

            <app-card-content [headerColor]="false" [title]="'Dados Matriz e Mantenedora'" [icon]="iconeDaSecao('Dados Matriz e Mantenedora')" [subtitle]="subtituloDaSecao('Dados Matriz e Mantenedora')">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">CRM Matriz</label>
                        <input pInputText formControlName="funcionamentoCrmMatriz" class="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">UF Matriz</label>
                        <p-select formControlName="funcionamentoUfMatriz" [options]="ufs" placeholder="UF" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">CNPJ Matriz</label>
                        <p-inputmask formControlName="funcionamentoCnpjMatriz" mask="99.999.999/9999-99" placeholder="00.000.000/0000-00" styleClass="w-full" />
                    </div>
                </div>

                <div class="field">
                    <label class="font-semibold block mb-2">Razão Social Matriz</label>
                    <input pInputText formControlName="funcionamentoRazaoSocialMatriz" class="w-full" />
                </div>

                <div class="grid grid-cols-1 md:grid-cols-[3fr_1fr] gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">Razão Social Mantenedora</label>
                        <input pInputText formControlName="funcionamentoRazaoSocialMantenedora" class="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Natureza Jurídica</label>
                        <p-select formControlName="funcionamentoNaturezaMantenedoraTipo" [options]="naturezaTipoOptions" placeholder="Selecionar" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                </div>
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaPrePrestador.DOC) {
            <app-card-content [headerColor]="false" [title]="'Registro e Licencas'" [icon]="iconeDaSecao('Registro e Licencas')" [subtitle]="subtituloDaSecao('Registro e Licencas')">
                <div class="grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr] gap-3">
                    <div class="field md:col-span-1">
                        <label class="font-semibold block mb-2">Local de Registro</label>
                        <p-select formControlName="docLocalRegistro" [options]="localRegistroOptions" placeholder="Selecionar" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">{{ documentoConstituicaoRotulo() }}</label>
                        <input pInputText formControlName="docDocumentoConstituicao" class="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">{{ numeroRegistroDocumentoRotulo() }}</label>
                        @if (ehJuntaComercialAtual()) {
                            <p-inputmask formControlName="docNumeroRegistroDocumento" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                        } @else {
                            <input pInputText formControlName="docNumeroRegistroDocumento" class="w-full" />
                        }
                    </div>
                </div>

                @if (!ehJuntaComercialAtual()) {
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                        <div class="field">
                            <label class="font-semibold block mb-2">N&uacute;mero Livro</label>
                            <input pInputText formControlName="docNumeroLivro" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">N&uacute;mero Folha</label>
                            <input pInputText formControlName="docNumeroFolha" class="w-full" />
                        </div>
                        <div class="field">
                            <label class="font-semibold block mb-2">Data</label>
                            <p-inputmask formControlName="docData" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                        </div>
                    </div>
                }

                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">Licença Sanitária</label>
                        <p-select formControlName="docLicencaSanitaria" [options]="licencaSanitariaOptions" placeholder="Selecionar" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Validade</label>
                        <p-inputmask formControlName="docValidade" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">Número Alvará de Funcionamento</label>
                        <input pInputText formControlName="docNumeroAlvara" class="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Data Alvará</label>
                        <p-inputmask formControlName="docDataAlvara" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Número CNES</label>
                        <input pInputText formControlName="docNumeroCnes" class="w-full" />
                    </div>
                </div>
            </app-card-content>

            <app-card-content [headerColor]="false" [title]="'Informacoes Assistenciais'" [icon]="iconeDaSecao('Informacoes Assistenciais')" [subtitle]="subtituloDaSecao('Informacoes Assistenciais')">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">Ensino</label>
                        <p-select formControlName="docEnsino" [options]="yesNoOptions" placeholder="Selecione" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Gestao</label>
                        <p-select formControlName="docGestao" [options]="yesNoOptions" placeholder="Selecione" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Tipo de Gestao</label>
                        <p-select formControlName="docTipoGestao" [options]="tipoGestaoOptions" placeholder="Selecione" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div class="field">
                        <label class="font-semibold block mb-2">Abrangência do Serviço</label>
                        <p-select formControlName="docAbrangenciaServico" [options]="abrangenciaServicoOptions" placeholder="Selecione" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">Condição de Funcionamento</label>
                        <p-select formControlName="docCondicaoFuncionamento" [options]="condicaoFuncionamentoOptions" placeholder="Selecione" styleClass="w-full pre-prestador-select" appendTo="body" panelStyleClass="pre-prestador-select-panel" />
                    </div>
                </div>
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaPrePrestador.SOCIETARIO) {
            <app-card-content [headerColor]="false" [title]="'Corpo Societário'" [icon]="iconeDaSecao('Corpo Societário')" [subtitle]="subtituloDaSecao('Corpo Societário')">
                @if (!corpoSocietario().length) {
                    <div class="colecao-feedback">Nenhum item encontrado para este protocolo.</div>
                } @else {
                    <div class="colecao-cards">
                        @for (socio of corpoSocietario(); track $index) {
                            <article class="colecao-card">
                                <div class="colecao-card-topo">
                                    <strong>{{ valorColecao(socio, ['nomeSocio', 'NOME']) || 'Socio nao informado' }}</strong>
                                    @if (valorColecao(socio, ['ufSocio', 'UF'])) {
                                        <span class="colecao-pill">{{ valorColecao(socio, ['ufSocio', 'UF']) }}</span>
                                    }
                                </div>
                                <p>CPF/CNPJ: {{ valorColecao(socio, ['cpfCnpjSocio', 'CNPJ']) || '-' }}</p>
                                <footer>{{ valorColecao(socio, ['emailSocio', 'EMAIL']) || 'E-mail nao informado' }}</footer>
                            </article>
                        }
                    </div>
                }
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaPrePrestador.CLINICO) {
            <app-card-content [headerColor]="false" [title]="'Corpo Clínico'" [icon]="iconeDaSecao('Corpo Clínico')" [subtitle]="subtituloDaSecao('Corpo Clínico')">
                @if (!corpoClinico().length) {
                    <div class="colecao-feedback">Nenhum item encontrado para este protocolo.</div>
                } @else {
                    <div class="colecao-cards">
                        @for (medico of corpoClinico(); track $index) {
                            <article class="colecao-card">
                                <div class="colecao-card-topo">
                                    <strong>{{ valorColecao(medico, ['nomeMedicoCorpoClinico', 'NOME']) || 'Medico nao informado' }}</strong>
                                </div>
                                <p>CRM: {{ valorColecao(medico, ['crmMedicoCorpoClinico', 'CRM', 'numeroCRMPSMT', 'NUMEROPSMT']) || '-' }} / {{ valorColecao(medico, ['ufCrmCorpoClinico', 'UF']) || '-' }}</p>
                                <p>V&iacute;nculo: {{ valorColecao(medico, ['vinculo.descricao', 'VINCULO']) || '-' }}</p>
                                @if (medico.especialidadesVinculadasPrestador?.length) {
                                    <footer>
                                        Especialidades:
                                        @for (especialidade of medico.especialidadesVinculadasPrestador; track $index) {
                                            <span>{{ especialidade.descricao || '-' }}</span>
                                            @if (!$last) {
                                                <span> | </span>
                                            }
                                        }
                                    </footer>
                                }
                            </article>
                        }
                    </div>
                }
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaPrePrestador.ESPECIALIDADES) {
            <app-card-content [headerColor]="false" [title]="'Especialidades'" [icon]="iconeDaSecao('Especialidades')" [subtitle]="subtituloDaSecao('Especialidades')">
                @if (!especialidades().length) {
                    <div class="colecao-feedback">Nenhum item encontrado para este protocolo.</div>
                } @else {
                    <div class="colecao-cards">
                        @for (item of especialidades(); track $index) {
                            <article class="colecao-card">
                                <div class="colecao-card-topo">
                                    <strong>{{ valorColecao(item, ['especialidade.descricao', 'DESCRICAO']) || 'Especialidade nao informada' }}</strong>
                                </div>
                                @if (item.areasAtuacao?.length) {
                                    <footer>
                                        &Aacute;reas:
                                        @for (area of item.areasAtuacao; track $index) {
                                            <span>{{ area.areaAtuacao?.descricao || '-' }}</span>
                                            @if (!$last) {
                                                <span> | </span>
                                            }
                                        }
                                    </footer>
                                }
                            </article>
                        }
                    </div>
                }
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaPrePrestador.AREA_ATUACAO) {
            <app-card-content [headerColor]="false" [title]="'Área de Atuação'" [icon]="iconeDaSecao('Área de Atuação')" [subtitle]="subtituloDaSecao('Área de Atuação')">
                @if (!areasAtuacao().length) {
                    <div class="colecao-feedback">Nenhum item encontrado para este protocolo.</div>
                } @else {
                    <div class="colecao-cards">
                        @for (item of areasAtuacao(); track $index) {
                            <article class="colecao-card">
                                <div class="colecao-card-topo">
                                    <strong>{{ valorColecao(item, ['areaAtuacao.descricao', 'DESCRICAO']) || 'Area nao informada' }}</strong>
                                </div>
                                <footer>Especialidade: {{ valorColecao(item, ['especialidade.descricao']) || '-' }}</footer>
                            </article>
                        }
                    </div>
                }
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaPrePrestador.SERVICOS) {
            <app-card-content [headerColor]="false" [title]="'Serviços'" [icon]="iconeDaSecao('Serviços')" [subtitle]="subtituloDaSecao('Serviços')">
                @if (!servicosPrestador().length) {
                    <div class="colecao-feedback">Nenhum item encontrado para este protocolo.</div>
                } @else {
                    <div class="colecao-cards">
                        @for (item of servicosPrestador(); track $index) {
                            <article class="colecao-card">
                                <div class="colecao-card-topo">
                                    <strong>{{ valorColecao(item, ['servico.descricao', 'DESCRICAO']) || 'Servico nao informado' }}</strong>
                                </div>
                                <footer>Chefe t&eacute;cnico CRM/UF: {{ valorColecao(item, ['crmChefeTecnico', 'CRM']) || '-' }} / {{ valorColecao(item, ['ufChefeTecnico', 'UF']) || '-' }}</footer>
                            </article>
                        }
                    </div>
                }
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaPrePrestador.ATIVIDADES) {
            <app-card-content [headerColor]="false" [title]="'Atividades'" [icon]="iconeDaSecao('Atividades')" [subtitle]="subtituloDaSecao('Atividades')">
                @if (!atividades().length) {
                    <div class="colecao-feedback">Nenhum item encontrado para este protocolo.</div>
                } @else {
                    <div class="colecao-cards">
                        @for (item of atividades(); track $index) {
                            <article class="colecao-card">
                                <p>{{ valorColecao(item, ['descricao', 'DESCRICAO']) || 'Atividade nao informada' }}</p>
                            </article>
                        }
                    </div>
                }
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaPrePrestador.REC_MATERIAIS) {
            <app-card-content [headerColor]="false" [title]="'Recursos Materiais'" [icon]="iconeDaSecao('Recursos Materiais')" [subtitle]="subtituloDaSecao('Recursos Materiais')">
                @if (!recursosMateriais().length) {
                    <div class="colecao-feedback">Nenhum item encontrado para este protocolo.</div>
                } @else {
                    <div class="colecao-cards">
                        @for (item of recursosMateriais(); track $index) {
                            <article class="colecao-card">
                                <div class="colecao-card-topo">
                                    <strong>{{ valorColecao(item, ['recursoMaterial.descricao', 'DESCRICAO']) || 'Recurso material nao informado' }}</strong>
                                </div>
                                <p>Quantidade: {{ valorColecao(item, ['quantidade', 'QUANTIDADE']) || '-' }}</p>
                                <footer>Tipo: {{ valorColecao(item, ['tipo', 'TIPO']) || '-' }}</footer>
                            </article>
                        }
                    </div>
                }
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaPrePrestador.REC_HUMANOS) {
            <app-card-content [headerColor]="false" [title]="'Recursos Humanos'" [icon]="iconeDaSecao('Recursos Humanos')" [subtitle]="subtituloDaSecao('Recursos Humanos')">
                @if (!recursosHumanos().length) {
                    <div class="colecao-feedback">Nenhum item encontrado para este protocolo.</div>
                } @else {
                    <div class="colecao-cards">
                        @for (item of recursosHumanos(); track $index) {
                            <article class="colecao-card">
                                <div class="colecao-card-topo">
                                    <strong>{{ valorColecao(item, ['recursoHumano.descricao', 'DESCRICAO']) || 'Recurso humano nao informado' }}</strong>
                                </div>
                                <p>Quantidade: {{ valorColecao(item, ['quantidade', 'QUANTIDADE']) || '-' }}</p>
                            </article>
                        }
                    </div>
                }
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaPrePrestador.PENDENTE) {
            <app-card-content [headerColor]="false" [title]="'Documentação Pendente'" [icon]="iconeDaSecao('Documentação Pendente')" [subtitle]="subtituloDaSecao('Documentação Pendente')">
                @if (!documentosPendentes().length) {
                    <div class="pendencia-feedback">Nenhum documento pendente para este protocolo.</div>
                } @else {
                    <div class="pendencia-cards">
                        @for (documentoPendente of documentosPendentes(); track $index) {
                            <article class="pendencia-card">
                                <p>{{ documentoPendente }}</p>
                            </article>
                        }
                    </div>
                }
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaPrePrestador.DESCONTOS) {
            <app-card-content [headerColor]="false" [title]="'Descontos'" [icon]="iconeDaSecao('Descontos')" [subtitle]="subtituloDaSecao('Descontos')">
                @if (!descontoMotivo()) {
                    <div class="desconto-feedback">Nenhuma informação de desconto para este protocolo.</div>
                } @else {
                    <article class="desconto-card">
                        <p>{{ descontoMotivo() }}</p>
                    </article>
                }
            </app-card-content>
        }

        @if (abaSelecionada() === EAbaPrePrestador.ANEXOS) {
            <div class="grid gap-5">
                <app-card-content [headerColor]="false" [title]="'Anexos Disponiveis'" [icon]="iconeDaSecao('Anexos Disponiveis')" [subtitle]="subtituloDaSecao('Anexos Disponiveis')">
                    @if (anexosDisponiveis().length === 0) {
                        <div class="feedback">Nenhum anexo disponível para visualização.</div>
                    } @else {
                        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                            @for (anexo of anexosDisponiveis(); track anexo.chave) {
                                <article class="campo campo--anexo">
                                    <span class="campo-label">{{ anexo.titulo }}</span>
                                    @if (possuiAnexo(anexo)) {
                                        <button type="button" class="campo-link-botao" (click)="onVisualizarAnexo($event, anexo)" aria-label="Visualizar anexo" title="Visualizar anexo">
                                            <i class="pi pi-paperclip"></i>
                                            <span>Visualizar anexo</span>
                                        </button>
                                    } @else {
                                        <strong class="campo-valor">-</strong>
                                    }
                                </article>
                            }
                        </div>
                    }
                </app-card-content>
            </div>
        }

        @if (jsonAtualizacao()) {
            <app-card-content [headerColor]="false" [title]="'JSON de Atualização'" [icon]="iconeDaSecao('JSON de Atualização')" [subtitle]="subtituloDaSecao('JSON de Atualização')">
                <pre>{{ jsonAtualizacao() }}</pre>
            </app-card-content>
        }
    </form>
</div>

<p-dialog
    appDialogoPadrao="pi pi-paperclip"
    descricao="Documento anexado ao registro."
    [visible]="exibirDialogAnexo()"
    (visibleChange)="exibirDialogAnexo.set($event)"
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    header="Visualização de anexo"
    (onHide)="fecharDialogAnexo()"
>
    @if (blobAnexo(); as blobAnexo) {
        <app-visualizador-pdf [src]="blobAnexo" [fileName]="nomeArquivoAnexo()" [showAll]="false"></app-visualizador-pdf>
    } @else {
        <div class="feedback">Nenhum anexo disponível para visualização.</div>
    }
</p-dialog>
